import { makeAutoObservable, runInAction } from "mobx";
import { FullOverlayModalsControl } from "../FullOverlayModalsControl";

class UserCurrentPanelState {
  FIO: string = "";
  EDIT_TYPE: "fio" | "password" | null = null;
  modalData: FullOverlayModalsControl = new FullOverlayModalsControl();

  constructor() {
    makeAutoObservable(this);
  }

  handleEdit = (typeEdit: "fio" | "password", fio?: string) => {
    this.setEditType(typeEdit);
    this.modalData?.isOpen();
    if (typeEdit === "fio") {
      this.setNewFio(fio || "");
    }
  };

  setEditType = (type: "fio" | "password" | null) => {
    runInAction(() => {
      this.EDIT_TYPE = type;
    });
  };

  setNewFio = (fio: string) => {
    runInAction(() => {
      this.FIO = fio;
    });
  };
}

export const userCurrentPanelState = new UserCurrentPanelState();
